<template>
    <div class="left-side" v-if="!empty">
		<div class="page-header m-t-n m-b-n p-b-n">
			<h1 class="m-n text-u-c">Meet Our team</h1>
      <div class="viewAll" v-if="views" @click="viewAll()">view all</div>
		</div>
		<div class="row m-t marginXs">
      <div v-for="member in members" :key="member.profile_id">
        <team-item :member="member"></team-item>
      </div>
		</div>		
    </div>
</template>

<script>

  import teamItem from '../team/team-item';
  import ApiService from "../../../../services/ApiService";

export default {
  components: {
    teamItem
  },
  data() {
    return {
      loader: false,
      apiService: new ApiService(),
      busy: false,
      empty: false,
      views: false,
      members: null,
      perPage: 5,
      page: 1
    }
  },
  created() {
    this.getMembers();
  },
  computed: {
    profile(){
      return this.$store.getters.profile;
    }
  },
  methods: {
    getMembers(merge = false) {
      if(!this.busy && !this.loader) {
        this.loader = true;
        this.apiService.get(`/corporate-profile-member?company_id=${this.profile.profile_id}&page=${this.page}&per-page=${this.perPage}`)
          .then(res => {
            this.busy = res._meta.currentPage >= res._meta.pageCount;
            this.empty = res._meta.totalCount === 0;
            this.views = res._meta.pageCount > res._meta.currentPage;
            if (merge) {
              this.members = this.members.concat(res.items);
            } else {
              this.members = res.items;
            }
            this.loader = false;
          })
      }
    },
    goMemberAdd(){
      window.location.assign(`${window.user.community_url}/${window.user.community_domain}/default/post/add`);
    },
    goMember(id){
      window.location.assign(`${window.user.community_url}/${window.user.community_domain}/default/profiles/view/${id}`);
    },
    addAWS(url) {
      if (!/^(f|ht)tps?:\/\//i.test(url)) {
        url =  process.env.AWS_URL + "/" + url;
      }
      return url;
    },
    viewAll() {
      this.$router.push('members');
    }
  }
}
</script>

<style lang="scss" scoped>
  .p-y {
    padding-bottom: 0 !important;
  }
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .lazy-image-main {
    max-width: 100% !important;
  }
  .lazy-image {
    max-width: 100% !important;
  }
  .img-rounded {
    width: 50px;
    height: 50px;
    border-radius: 100%;
  }
  h2 {
    line-height: 60%;
  }
  .page-header {
    margin-top: 17px;
    margin-bottom: 0;
    color: #000;
  }
  .page-header h1 {
    font-style: normal;
    font-weight: 300 !important;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.72px;
  }
@media only screen and (min-width: 1200px) {
	.page-header h1 {
		line-height: 28px;
	}
}

@media only screen and (max-width: 1199px) and (min-width: 768px) {
}
	
@media only screen and (max-width: 767px) {
  .page-header {
    margin-top: 20px;
    margin-bottom: 0px;
  }
  .marginXs {
    margin-left: 10%;
    margin-right: 10%;
  }
}
.viewAll {
  cursor: pointer;
  font-size: 12px;
  line-height: 14px;
  color: #555;
}
</style>

